import { Toast } from "primereact/toast";
import React, { useContext } from "react";
import { AppContext } from "../Store";

export default function GrowlMessage() {
  const { growlMessage } = useContext(AppContext);

  return <Toast ref={growlMessage} />;
}
